import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import { Context } from "contexts/contextState";
import { User } from "models/User";
import PropTypes from "prop-types";
import { useContext, useState } from "react";
import { errorAlert, successAlert } from "views/components/Alerts";

export function CompletePaymentPersonModal(props) {
  const { context } = useContext(Context);
  const [processing, setProcessing] = useState(false);

  async function handleConfirmCoursePayment() {
    setProcessing(true);
    try {
      const customer = new User(props.customer);
      customer.payInPersonPurchases = customer.payInPersonPurchases.filter(purchase => props.course.id != purchase);
      customer.purchases.push(props.course.id);
      await context.userRepository.saveUser(customer);
      successAlert("Success!", "The customer payment has been completed.").then(() => {
        window.location.reload();
      });
      props.onClose();
    } catch (error) {
      console.log("handleConfirmCoursePayment", error);
      errorAlert("Error!", "Failed to complete customer payment in our database. Please check your connection and try again. If the issue persists, please contact our support team for assistance.");
    } finally {
      setProcessing(false);
    }
  }

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle>
        Are you certain you want to confirm this &quot;Pay In Person&quot; payment?
      </DialogTitle>
      <DialogContent>
        <SoftTypography variant="body2">
          If you the payment for <b>{(props.course?.title || "").trim()}</b>, it cannot be recovered. <br />Are you sure you want to proceed?
        </SoftTypography>
      </DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="space-between" flex="1">
          <SoftButton variant="text" color="error" onClick={props.onClose}>
            Cancel
          </SoftButton>
          <SoftButton
            disabled={!(context.permission.root || context.permission.customer.update) || processing}
            variant="text" color="info" onClick={handleConfirmCoursePayment}
          >
            Confirm
          </SoftButton>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

CompletePaymentPersonModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  course: PropTypes.object.isRequired,
  customer: PropTypes.object.isRequired,
};